import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "30",
  height: "30",
  "xml:space": "preserve"
}

function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, _cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      "fill-rule": "evenodd",
      "clip-rule": "evenodd",
      d: "M25 19.18v-6.07c0-1.64-1.17-2.99-2.67-3.15v6.02c0 2.53-1.92 4.58-4.29 4.58h-6.6c-.45.44-.9.8-1.33 1.1.51.43 1.15.69 1.85.69h7.14c2.85 3.11 5.89 2.48 5.28 2-.9-.73-1.37-1.45-1.58-2.1 1.26-.37 2.2-1.6 2.2-3.07zm-6.96-.04c1.64 0 2.96-1.42 2.96-3.16V9.91c0-1.75-1.33-3.16-2.96-3.16H7.96C6.32 6.74 5 8.16 5 9.91v6.07c0 1.47.94 2.7 2.2 3.06-.21.66-.68 1.37-1.58 2.1-.24.19.09.4.74.4 1.01 0 2.81-.51 4.55-2.4h7.13z"
    }, null, -1)
  ])))
}
export default { render };